import { forwardRef } from "react";
import { Icon } from "@circle-react-shared/Icon";
import { ToolbarButton } from "../Button";
import type { ToolbarButtonProps } from "../Button";

export interface ToolbarDropdownButtonProps extends ToolbarButtonProps {
  "aria-expanded"?: boolean;
}

export const ToolbarDropdownButton = forwardRef<
  HTMLButtonElement,
  ToolbarDropdownButtonProps
>((props, ref) => {
  const isOpen = !!props["aria-expanded"];
  return (
    <ToolbarButton {...props} forwardedRef={ref} active={isOpen}>
      <Icon type={isOpen ? "20-chevron-up" : "20-chevron-down"} size={20} />
    </ToolbarButton>
  );
});

ToolbarDropdownButton.displayName = "ToolbarDropdownButton";
